import { Filter, Position, Zone } from '../../../interfaces'
import { SortField } from '../../../interfaces/DataGrid/DataGridSettings'
import {
  IBusquedaPosition,
  PositionAutoComplete,
  PositionGrid,
  PositionSubZone
} from '../../../interfaces/Position/Position'
import { actionTypes } from '../types'
import { SaveTypePosition } from '../types/reducerTypes'
/*
Copyright 2022-08-24 por miguel balloqui Ecomsur Holding S.A ©
Detalle: Se agregan positionActions
*/

const positionActions = () => {
  const switchModal = (showModal: boolean): actionTypes => ({
    type: 'SWITCH_MODAL',
    payload: showModal
  })

  const switchModalDelete = (showModalDelete: boolean): actionTypes => ({
    type: 'SWITCH_MODAL_DELETE',
    payload: showModalDelete
  })

  const switchModalView = (showModalView: boolean): actionTypes => ({
    type: 'SWITCH_MODAL_VIEW',
    payload: showModalView
  })

  const switchModalRedireccion = (
    showModalRedireccion: boolean
  ): actionTypes => ({
    type: 'SWITCH_MODAL_REDIRECCION',
    payload: showModalRedireccion
  })

  const changePage = (page: number): actionTypes => ({
    type: 'CHANGE_PAGE',
    payload: page
  })

  const changePageSize = (pageSize: number): actionTypes => ({
    type: 'CHANGE_PAGE_SIZE',
    payload: pageSize
  })

  const setTotalItems = (totalItems: number): actionTypes => ({
    type: 'SET_TOTAL_ITEMS',
    payload: totalItems
  })

  const setIdForDelete = (idForDelete: number | undefined): actionTypes => ({
    type: 'SET_ID_FOR_DELETE',
    payload: idForDelete
  })

  const switchEditableItem = (
    positionEditable: Position | undefined
  ): actionTypes => ({
    type: 'SWITCH_EDITABLE_ITEM',
    payload: positionEditable
  })

  const switchSnackBar = (showSnackBar: boolean): actionTypes => ({
    type: 'SWITCH_SNACKBAR',
    payload: showSnackBar
  })

  const setMessageColor = (messageColor: string): actionTypes => ({
    type: 'SET_MESSAGE_COLOR',
    payload: messageColor
  })

  const setMessageStatus = (messageStatus: string): actionTypes => ({
    type: 'SET_MESSAGE_STATUS',
    payload: messageStatus
  })

  const setChangePage = (value: number): actionTypes => ({
    type: 'CHANGE_PAGE',
    payload: value
  })

  const setChangePageSize = (value: number): actionTypes => ({
    type: 'CHANGE_PAGE_SIZE',
    payload: value
  })

  const setRows = (rows: PositionGrid[]): actionTypes => ({
    type: 'SET_ROWS',
    payload: rows
  })

  const setBusqueda = (busqueda: IBusquedaPosition): actionTypes => ({
    type: 'SET_BUSQUEDA',
    payload: busqueda
  })

  const setGridStatus = (gridStatus: string): actionTypes => ({
    type: 'SET_GRID_STATUS',
    payload: gridStatus
  })

  const setGridError = (gridError: string): actionTypes => ({
    type: 'SET_GRID_ERROR',
    payload: gridError
  })

  const setFilters = (filters: Filter[]): actionTypes => ({
    type: 'SET_FILTERS',
    payload: filters
  })

  const setAlmacenesDDL = (wareHouses: []): actionTypes => ({
    type: 'SET_ALMACENES_DDL',
    payload: wareHouses
  })

  const setIsLoading = (loading: boolean): actionTypes => ({
    type: 'SET_IS_LOADING',
    payload: loading
  })

  const setAllSubZones = (
    positionSubzones: PositionSubZone[]
  ): actionTypes => ({
    type: 'SET_ALL_SUBZONES',
    payload: positionSubzones
  })

  const setSubZonesInZone = (
    subZonesInZone: PositionSubZone[]
  ): actionTypes => ({
    type: 'SET_SUBZONES_INZONE',
    payload: subZonesInZone
  })

  const saveTypePositionDDL = (
    typePosition: SaveTypePosition
  ): actionTypes => ({
    type: 'SAVE_TYPE_POSITION_DDL',
    payload: typePosition
  })

  const setZoneDDL = (zones: Zone[]): actionTypes => ({
    type: 'SET_ZONE_DDL',
    payload: zones
  })

  const setRedirect = (redirect: boolean): actionTypes => ({
    type: 'SET_REDIRECT',
    payload: redirect
  })
  const setLoaderCode = (loaderCode: boolean): actionTypes => ({
    type: 'SET_LOADER_CODE',
    payload: loaderCode
  })
  const setLoaderName = (loaderName: boolean): actionTypes => ({
    type: 'SET_LOADER_NAME',
    payload: loaderName
  })

  const setPosiciones = (posiciones: PositionAutoComplete[]): actionTypes => ({
    type: 'SET_POSICIONES',
    payload: posiciones
  })

  const setSorters = (sorters: SortField[]): actionTypes => ({
    type: 'SET_SORTERS',
    payload: sorters
  })

  const setItemsQuantity = (itemsQuantity: number): actionTypes => ({
    type: 'SET_ITEMS_QUANTITY',
    payload: itemsQuantity
  })

  const setFirstEffect = (firstEffect: boolean): actionTypes => ({
    type: 'SET_FIRST_EFFECT',
    payload: firstEffect
  })

  const switchModalPositionMassive = (showModal: boolean): actionTypes => ({
    type: 'SWITCH_MODAL_POSITION_MASSIVE',
    payload: showModal
  })

  const setEditModePositionMassive = (editMode: boolean): actionTypes => ({
    type: 'SET_EDIT_MODE_POSITION_MASSIVE',
    payload: editMode
  })

  const setLoadingExport = (status: boolean): actionTypes => ({
    type: 'SET_LOADING_EXPORT',
    payload: status
  })

  return {
    switchModal,
    switchModalDelete,
    switchModalView,
    switchModalRedireccion,
    changePage,
    changePageSize,
    setIdForDelete,
    switchEditableItem,
    switchSnackBar,
    setMessageColor,
    setMessageStatus,
    setRows,
    setBusqueda,
    setGridStatus,
    setGridError,
    setFilters,
    setAlmacenesDDL,
    setIsLoading,
    setAllSubZones,
    setSubZonesInZone,
    saveTypePositionDDL,
    setZoneDDL,
    setRedirect,
    setLoaderCode,
    setLoaderName,
    setPosiciones,
    setSorters,
    setChangePage,
    setChangePageSize,
    setTotalItems,
    setItemsQuantity,
    setFirstEffect,
    switchModalPositionMassive,
    setEditModePositionMassive,
    setLoadingExport
  }
}

export default positionActions
